import { useEffect } from 'react'

import isEmpty from 'lodash/isEmpty'
import { useDispatch, useSelector } from 'react-redux'
import { fetchPendingApproval } from 'Redux/approver/actions'

const useApproverCartsPending = () => {
  const dispatch = useDispatch()

  const pendingApproval = useSelector(state => state.approver.pendingApproval)
  const closeToAutoApproved = useSelector(state => state.approver.closeToAutoApproved)
  const isFetching = useSelector(state => state.approver.isFetchingPendingApproval)
  const filterCenter = useSelector(state => state.approver.filterCenter)
  const filterProviders = useSelector(state => state.approver.filterProviders)
  const filterRequestNumber = useSelector(state => state.approver.filterRequestNumber)

  const isFilterActive = !!filterCenter || !!filterProviders?.length || !!filterRequestNumber

  useEffect(() => {
    dispatch(fetchPendingApproval())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterCenter, filterProviders, filterRequestNumber])

  const noResults = isEmpty(pendingApproval) && isEmpty(closeToAutoApproved)

  return { noResults, isFetching, data: { closeToAutoApproved, pendingApproval }, isFilterActive }
}

export default useApproverCartsPending
